import React, { useContext, useRef } from "react";
import clsx from "clsx";
import isEmpty from "lodash/isEmpty";
import loadable from "@loadable/component";
import PageContext from "@PageContext";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import Local from "@Local";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Animation.styles";

const ReactAnimation = loadable(() =>
	import("@micado-digital/react-animation/ReactAnimation")
);
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Animation = () => {
	const { REACT_APP_PATH } = process.env;
	const [pageData] = useContext(PageContext);
	const { animationID, lang, layoutVariant } = pageData;
	const css = styles();
	const $wrapper = useRef(null);
	const isIntro = layoutVariant === "intro";

	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	if (isEmpty(pageData)) return null;

	let mediaFormats = {};

	if (isIntro) {
		mediaFormats = {
			xs: "animation-intro-small",
			sm: "animation-intro-medium",
			lg: "animation-intro"
		};
	} else {
		mediaFormats = {
			xs: "animation-small",
			sm: "animation-medium",
			lg: "animation"
		};
	}

	const handleScrollToContent = () => {
		const $elements = document.querySelector(".mco-elements");

		if ($elements) {
			$elements.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	};

	return (
		<div
			className={clsx(css.animationWrapper, "mco-view-component-animation-wrapper", {
				[css.animationWrapperIntro]: isIntro,
				"mco-view-component-animation-wrapper--intro": isIntro
			})}
			ref={$wrapper}
		>
			<div className={clsx(css.animation, "mco-view-component-animation")}>
				<ReactAnimation
					api={`${REACT_APP_PATH}/animationV3.json.api`}
					id={animationID}
					lang={lang}
					mediaFormats={mediaFormats}
					showBullets
					textComponents={{
						text1: "p",
						text2: "p"
					}}
					webpFallback
				/>
				<div
					className={clsx(css.scrollBottom, "mco-view-component-animation__scroll-bottom")}
					onClick={handleScrollToContent}
				>
					<Local identifier="animation.scroll" l={l} />
					<ReactSVGIcon src="/img/icons/arrow-left.svg" width={24} />
				</div>
			</div>
		</div>
	);
};

export default Animation;
